module.exports = __webpack_public_path__ + "static/media/ruler.e58b5cfc.svg";